<template>
  <div class="app-layout">
    <v-fade-transition>
      <div
        v-if="loading !== true"
        class="app-layout-root"
        :style="{height: height + 'px'}"
        ref="appLayoutRoot"
        v-resize="onResize"
      >
        <div class="app-toolbar">
          <slot name="header"></slot>
        </div>
        <div
          class="app-layout-content"
          ref="appLayoutContent"
          :style="{height: contentHeight + 'px'}"
        >
          <slot></slot>
        </div>
        <div class="app-footer" ref="appLayoutFooter">
          <slot name="footer"></slot>
        </div>
      </div>
      <div v-else class="loading-container">
        <v-progress-circular indeterminate color="primary" size="100" width="10"></v-progress-circular>
      </div>
    </v-fade-transition>
  </div>
</template>

<script>
export default {
  name: "AppLayout",
  props: ["loading"],
  data() {
    return {
      height: 0,
      contentHeight: 0
    };
  },

  watch: {
    loading: function(val) {
      if (!val) setTimeout(() => this.refreshRectPositions(), 500);
    }
  },

  methods: {
    refreshRectPositions() {
      if (this.loading) return;
      let dif = this.$refs.appLayoutRoot.getBoundingClientRect().top;
      this.height = this.$vuetify.breakpoint.height - dif;
      let dif2 = this.$refs.appLayoutContent.getBoundingClientRect().top;
      let dif3 = this.$refs.appLayoutFooter.getBoundingClientRect().height;
      this.contentHeight = this.$vuetify.breakpoint.height - dif2 - dif3;
    },

    onResize() {
      setTimeout(() => this.refreshRectPositions(), 500);
    }
  },

  mounted() {
    setTimeout(() => this.refreshRectPositions(), 500);
  }
};
</script>

<style lang="scss">
html {
  overflow: hidden;
}

.app-layout {
  width: 100%;
  height: 100%;
  background-color: white;
  .loading-container,
  .error-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.app-layout-root {
  width: 100%;

  > .app-layout-content {
    overflow: auto;
  }
}
</style>
